export default __webpack_public_path__ + "static/media/arrow_forward_backward.8a89eeef.svg";